import { render, staticRenderFns } from "./NotificationTask.vue?vue&type=template&id=79c8ad42&scoped=true"
import script from "./NotificationTask.vue?vue&type=script&lang=ts"
export * from "./NotificationTask.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTask.vue?vue&type=style&index=0&id=79c8ad42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c8ad42",
  null
  
)

export default component.exports